export enum PasswordStrengthLevel {
  WEAK = 0,
  MEDIUM = 1,
  STRONG = 2,
}

export enum PasswordStrengthSuggestion {
  LENGTH = 'LENGTH',
  MEDIUM = 'MEDIUM',
  COMMON = 'COMMON',
  STRONG = 'STRONG',
  HISTORY = 'HISTORY',
  SEQUENCE = 'SEQUENCE', // Common character sequences like "abc" are easy to guess.
  SIMPLE_REPEAT = 'SIMPLE_REPEAT', // Repeated characters like "aaa" are easy to guess.
  REPEAT_EXTENDED = 'REPEAT_EXTENDED', // Repeated character patterns like "abcabcabc" are easy to guess.
  STRAIGHT_ROW = 'STRAIGHT_ROW', // Straight rows of keys on your keyboard are easy to guess.
}

export interface PasswordStrengthResult {
  passwordStrengthLevel: PasswordStrengthLevel;
  suggestions: PasswordStrengthSuggestion[];
}

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MIN_SCORE_TO_EVAL_SUGGESTIONS = 2;

export const WARNING_TO_SUGGESTION_MAP: Record<string, PasswordStrengthSuggestion> = {
  similarToCommon: PasswordStrengthSuggestion.COMMON,
  common: PasswordStrengthSuggestion.COMMON,
  topTen: PasswordStrengthSuggestion.COMMON,
  topHundred: PasswordStrengthSuggestion.COMMON,
  extendedRepeat: PasswordStrengthSuggestion.REPEAT_EXTENDED,
  straightRow: PasswordStrengthSuggestion.STRAIGHT_ROW,
  simpleRepeat: PasswordStrengthSuggestion.SIMPLE_REPEAT,
  sequences: PasswordStrengthSuggestion.SEQUENCE,
};
